import React from 'react';
import { connect } from 'react-redux';
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import { ThanhTra } from 'api';
import { RowItemDanhSachCuocThanhTra } from 'modules/thanh-tra/datatable';
import ThemMoiDoiTuongThanhTra from './ThemMoiDoiTuongThanhTra.jsx';

class DanhSachCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      linhVucThanhTraList: [],
      donViChuTriList: [],
      allowDelete: true
    }
  }

  componentDidMount() {
    this.getLinhVucThanhTra();
    this.getDonViChuTri();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      nextProps.data.cuocThanhTras.map(item => {
        if (item.tienDoThanhTraInfo !== null) {
          this.state.allowDelete = false;
        }
        this.state.data.push(item);
      });
      this.setState({...this.state});
      this.props.onChange(this.state.data);
    }
  }

  getLinhVucThanhTra() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.state.linhVucThanhTraList = res.data;
      } else {
        this.state.linhVucThanhTraList = [];
      }
      this.setState({...this.state});
    });
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViChuTri.request().then(res => {
      if (res.data && res.data._embedded) {
        this.state.donViChuTriList = res.data._embedded.coQuanQuanLies;
      } else {
        this.state.donViChuTriList = [];
      }
      this.setState({...this.state});
    });
  }

  handleRemove(item, index) {
    if (item.id) {
      this.props.onRemove(item.id);
    }
    this.state.data.splice(index, 1);
    this.setState({...this.state});
    this.props.onChange(this.state.data);
  }

  handleExportData(data) {
    let idList = [];
    this.state.data.map(item => {
      idList.push(item.doiTuongThanhTraId);
    });
    data.map(item => {
      if (idList.indexOf(item.doiTuongThanhTraId) === -1) {
        let newItem = {
          doiTuongThanhTraInfo: item,
          noiDungThanhTra: '',
          donViChuTriInfo: {
            coQuanQuanLyId: '',
            ten: ''
          },
          donViPhoiHop: '',
          kyThanhTra: '',
          linhVucThanhTraInfo: {
            text: '',
            type: ''
          },
          thoiHanThanhTra:''
        }
        this.state.data.push(newItem);
      }
      return;
    });
    this.setState({...this.state});
    this.props.onChange(this.state.data);
  }
  onSave(data) {
    this.state.data.map(item => {
      if (item.doiTuongThanhTraInfo.doiTuongThanhTraId === data.doiTuongThanhTraInfo.doiTuongThanhTraId) {
        item = data;
      }
    });
    this.setState({...this.state});
    this.props.onChange(this.state.data);
  }

  render() {
    return (
      <section className='wrap-block'>
        <div className='row pl10 pr10 heading-addnew-dttt'>
          <h2 className='title-14 col-100 pt10 pl20 pr20 pb15'>2. Danh sách cuộc thanh tra</h2>
          <ThemMoiDoiTuongThanhTra exportData={this.handleExportData.bind(this)} importData={this.state.data} namThanhTra={this.props.namThanhTra}/>
        </div>
        <div className='row pl10 pr10 '>
          <DataTable header={ header.thanhTra.DKKHTT } plusColum={1} dataList={ this.state.data } hideButtonExport={true} hidePagination={ true } pageData={ this.state.pageData } parent={ this }
            tableLoading={ this.state.tableLoading }>
            <RowItemDanhSachCuocThanhTra allowDelete={this.state.allowDelete} onSave={this.onSave.bind(this)}/>
          </DataTable>
        </div>
      </section>
    );
  }
}

DanhSachCuocThanhTra.defaultProps = {
  data: {}
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}
export default connect(bindStateToProps)(DanhSachCuocThanhTra);


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/DanhSachCuocThanhTra.jsx